import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  AppPageComponent,
  AppSidenavComponent,
  AppBarComponent,
  AppBarTitleComponent,
  AppBarActionsComponent,
  AppBarExpandedTabsComponent
} from 'common';
import { appPageComponentDataMaster, appPageComponentDataDetail } from '../../app.data';
import { UserMenuComponent } from '../../user/user-menu/user-menu.component';
import { FailureReasonListComponent } from './failure-reason-list/failure-reason-list.component';
import { FailureReasonDetailsComponent } from './failure-reason-details/failure-reason-details.component';
import { FailureReasonQueryResolver, FailureReasonResolver } from './failure-reason.resolver';
import { AppPageResolver, AppSidenavResolver } from '../../app.resolver';
import { AdminAppBarExpandedTabsResolver } from '../admin.resolver';
import { BOAuthGuard } from '../../guards/oauth.guard';

const appPageDataMaster = appPageComponentDataMaster({
  appBarTitle: 'Admin',
  sideNavItem: 'admin'
});
const appPageDataDetail = appPageComponentDataDetail();

const routes: Routes = [
  {
    path: '',
    canActivate: [BOAuthGuard],
    children: [
      {
        path: 'admin/failurereason',
        component: AppPageComponent,
        data: appPageDataMaster,
        resolve: {
          appBarExpandedTabs: AdminAppBarExpandedTabsResolver,
          appPage: AppPageResolver,
          appSidenav: AppSidenavResolver
        },
        children: [
          {
            path: '',
            outlet: 'sidenav-content',
            component: AppSidenavComponent
          },
          {
            path: '',
            component: AppBarComponent,
            outlet: 'app-bar',
            children: [
              {
                path: '',
                outlet: 'title',
                component: AppBarTitleComponent,
              },
              {
                path: '',
                outlet: 'right',
                component: UserMenuComponent,
              },
              {
                path: '',
                outlet: 'expanded',
                component: AppBarExpandedTabsComponent
              }
            ]
          },
          {
            path: '',
            component: FailureReasonListComponent,
            runGuardsAndResolvers: "paramsOrQueryParamsChange",
            resolve: {
              failureReasonQueryResult: FailureReasonQueryResolver
            }
          }
        ]
      },
      {
        path: 'admin/failurereason/:id',
        component: AppPageComponent,
        data: appPageDataDetail,
        children: [
          {
            path: '',
            component: AppBarComponent,
            outlet: 'app-bar',
            children: [
              {
                path: '',
                outlet: 'title',
                component: AppBarTitleComponent,
              },
              {
                path: '',
                outlet: 'right',
                component: AppBarActionsComponent,
              }
            ]
          },
          {
            path: '',
            component: FailureReasonDetailsComponent,
            resolve: {
              failureReason: FailureReasonResolver
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FailureReasonRoutingModule { }
